<template>
  <div class="pregled-vsebine">
    <div class="postavitev-izbirnika">
      <div class="izbirnik-stranke">
        <div>
          <IzbirnikStranke v-on:osvezitevIzbranihPodatkovStranke="GetStranka"/>
        </div>
      </div>
    </div>
    <div style="clear: both"/>
    <div class="vsebina-postavitev">
      <div class="odmik-vsebine">
        <div v-if="izbranaStrankaSap !== null">
          <p class="open-sans-30pt">
            {{ title }}
          </p>
          <div style="padding-top: 10px">
            <el-tabs type="border-card" @tab-click="HandleTabClick" value="t1">
              <el-tab-pane label="Izdani računi" name="t1" ref="t1">
                <div v-if="activetab === 't1'">
                  <IzdaniRacuni :izbranSap="izbranaStrankaSap"
                                :izbranIdStranka="izbranIdStranka"
                                :seznam-racunov="seznamRacunovBrezObrokov"/>
                </div>
              </el-tab-pane>
              <el-tab-pane label="Izdani računi za naprave" name="t2" ref="t2">
                <div v-if="activetab === 't2'">
                  <IzdaniRacuniZaNaprave :izbranSap="izbranaStrankaSap"
                                :prikazObrokov="prikazObrokov"/>
                </div>
              </el-tab-pane>
              <el-tab-pane label="Stroškovni nosilci" name="t3" ref="t3">
                <div v-if="activetab === 't3'">
                  <PermissionComponent :permissionId="'STRANKE'"
                                       :parameterKey="'id_stranka'"
                                       :parameterValue="izbranIdStranka"
                                       :showError="true" >
                  <StroskovniNosilci :izbranSap="izbranaStrankaSap"
                                     :izbranIdStranka="izbranIdStranka"/>
                  </PermissionComponent>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import IzdaniRacuni from './Racuni/IzdaniRacuni.vue'
import StroskovniNosilci from './Racuni/StroskovniNosilci.vue'
import IzbirnikStranke from '../GlobalneKomponente/IzbirnikStranke.vue'
import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'
import {Select, Option, TabPane, Tabs} from 'element-ui'
import ClientAgent from '../../../../assets/js/clientAgent.js'
import PermissionComponent from '../GlobalneKomponente/PermissionComponent'
import Vue from 'vue'
import IzdaniRacuniZaNaprave from './Racuni/IzdaniRacuniZaNaprave.vue'
import {FormatDatuma} from '../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/FormatDatuma'

export default {
  name: 'Racuni',
  mixins: [PrikazVsebine, FormatDatuma],
  data () {
    return {
      title: 'Pregled izdanih računov',
      clientAgent: null,
      activetab: 't1',
      izbranaStrankaSap: null,
      izbranIdStranka: null,
      seznamRacunov: [],
      seznamRacunovBrezObrokov: [],
      prikazObrokov: [],
      response: null
    }
  },
  components: {
    IzdaniRacuniZaNaprave,
    'IzbirnikStranke': IzbirnikStranke,
    'IzdaniRacuni': IzdaniRacuni,
    'StroskovniNosilci': StroskovniNosilci,
    [Select.name]: Select,
    [Option.name]: Option,
    [TabPane.name]: TabPane,
    [Tabs.name]: Tabs,
    PermissionComponent
  },
  watch: {
    izbranaStrankaSap () {
      if (this.izbranaStrankaSap !== null) {
        this.prikazObrokov = []
        this.seznamRacunovBrezObrokov = []
        if (this.activetab === 't1') {
          this.GetSeznamRacunov()
        }
        if (this.activetab === 't2') {
          this.PridobiObrokeRacuna()
        }
      }
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
  },
  methods: {
    GetStranka (podatkiStranke) {
      if (podatkiStranke.id_stranka !== null && podatkiStranke.id_stranka_sap !== null) {
        this.izbranaStrankaSap = ''
        this.izbranIdStranka = podatkiStranke.id_stranka
        this.izbranaStrankaSap = podatkiStranke.id_stranka_sap
      }
    },
    GetSeznamRacunov () {
      if (this.izbranaStrankaSap !== null) {
        this.loadingSeznamRacunov = true
        let param = ['sap=' + this.izbranaStrankaSap]
        this.clientAgent.postWsRequest(
          this,
          'stranka/racun/info',
          param,
          null,
          'SetSeznamRacunov',
          'ErrSeznamRacunov')
      }
    },
    SetSeznamRacunov (podatki) {
      this.seznamRacunovBrezObrokov = []
      this.seznamRacunov = []
      this.seznamRacunov = podatki.racuni
      let veljavniRacuni = []
      for (let i = 0; i < this.seznamRacunov.length; i++) {
        Vue.set(this.seznamRacunov[i], 'index', i)
        if (!Array.isArray(this.seznamRacunov[i].KLJUC)) {
          let racun = this.seznamRacunov[i]
          racun.KLJUC = this.seznamRacunov[i].KLJUC
          if (!Array.isArray(this.seznamRacunov[i].DATDOK)) {
            racun.DATDOKC_izpis = this.seznamRacunov[i].DATDOK
          } else {
            racun.DATDOKC_izpis = 0
          }
          if (this.seznamRacunov[i].SALDO <= 0) {
            racun.placano_izpis = 'DA'
          } else {
            racun.placano_izpis = 'NE'
          }
          Vue.set(racun, 'leto', this.seznamRacunov[i].DATOBD.slice(-4))
          veljavniRacuni.push(racun)
        }
        if (this.seznamRacunov[i].OBROK === '0') {
          this.seznamRacunovBrezObrokov.push(this.seznamRacunov[i])
        }
      }
    },
    PridobiObrokeRacuna () {
      if (this.izbranaStrankaSap !== null) {
        let param = ['sap=' + this.izbranaStrankaSap]
        this.clientAgent.postWsRequest(
          this,
          'stranka/racun/prikazRacunovZObroki',
          param,
          null,
          'SetPridobiObrokeRacuna',
          'ErrPridobiObrokeRacuna')
      }
    },
    SetPridobiObrokeRacuna (podatki) {
      this.prikazObrokov = []
      for (let i = 0; i < podatki.racuni.length; i++) {
        if (podatki.racuni[i].stVsehObrokov !== 0) {
          let prestejemplacane = 0
          for (let j = 0; j < podatki.racuni[i].obroki.length; j++) {
            if (podatki.racuni[i].obroki[j].placano) {
              prestejemplacane++
            }
            if (podatki.racuni[i].obroki[j].znesekObroka !== null) {
              let num = podatki.racuni[i].obroki[j].znesekObroka
              let result = num.toFixed(2)
              podatki.racuni[i].obroki[j].znesekObroka = result
            }
            if (podatki.racuni[i].obroki[j].znesekPlacila !== null) {
              let num = podatki.racuni[i].obroki[j].znesekPlacila
              let result = num.toFixed(2)
              podatki.racuni[i].obroki[j].znesekPlacila = result
            }
            if (podatki.racuni[i].obroki[j].datumPlacila !== null) {
              let izpisFormatDatumaDatumPlacila =
                this.PoenotenIzgledDatumaBrezCasa(podatki.racuni[i].obroki[j].datumPlacila.date)
              podatki.racuni[i].obroki[j].datumPlacila = izpisFormatDatumaDatumPlacila
            } else {
              podatki.racuni[i].obroki[j].datumPlacila = null
            }
            if (podatki.racuni[i].obroki[j].rokPlacila !== null) {
              let izpisFormatDatumaRokPlacila =
                this.PoenotenIzgledDatumaBrezCasa(podatki.racuni[i].obroki[j].rokPlacila.date)
              podatki.racuni[i].obroki[j].rokPlacila = izpisFormatDatumaRokPlacila
            } else {
              podatki.racuni[i].obroki[j].rokPlacila = null
            }
          }
          let leto = podatki.racuni[i].datumIzdaje.date.slice(0, 4)
          Vue.set(podatki.racuni[i], 'leto', leto)
          Vue.set(podatki.racuni[i], 'steviloPlacanih', prestejemplacane)
          this.prikazObrokov.push(podatki.racuni[i])
        }
      }
    },
    HandleTabClick (tab) {
      this.activetab = tab.name
      if (this.activetab === 't1') {
        this.GetSeznamRacunov()
      }
      if (this.activetab === 't2') {
        this.PridobiObrokeRacuna()
      }
    }
  }
}
</script>
<style scoped src="../../../../../static/css/MojT-2/Racuni/Racuni.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/MojT2/Racuni.vue